export const SET_ORGS = 'org/SET_ORGS';
export const SET_CURRENT_ORG = 'org/SET_CURRENT_ORG';
export const SET_ORG_MEMBERS = 'org/SET_ORG_MEMBERS';
export const SET_ORGS_LOADING = 'org/SET_ORGS_LOADING';
export const ADD_ORG = 'org/ADD_ORG';
export const ADD_ORG_MEMBER = 'org/ADD_ORG_MEMBER';
export const SET_ORG_USER_INFO = 'org/SET_ORG_USER_INFO';
export const UPDATE_ORG_MEMBER_INFO = 'org/UPDATE_ORG_MEMBER_INFO';